import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select'
import { Switch } from '@/components/ui/Switch'
import { IconPicker } from '@/components/ui/IconPicker'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
} from '@/components/ui/Dialog'

export interface TopicFormData {
  name: string
  icon: string
  description: string
  inbox_id: string
  active: boolean
  channel_ids: string[]
}

interface Inbox {
  id: string
  name: string
}

interface TopicFormDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  formData: TopicFormData
  onFormChange: (data: TopicFormData) => void
  onSubmit: () => void
  isEditing: boolean
  inboxes: Inbox[]
}


export function TopicFormDialog({
  open,
  onOpenChange,
  formData,
  onFormChange,
  onSubmit,
  isEditing,
  inboxes,
}: TopicFormDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{isEditing ? 'Edit Topic' : 'Create Topic'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="topic-name">Topic Name *</Label>
            <Input
              id="topic-name"
              value={formData.name}
              onChange={(e) => onFormChange({ ...formData, name: e.target.value })}
              placeholder="e.g., Sales, Support, Billing"
            />
          </div>

          <div className="space-y-2">
            <Label>Icon</Label>
            <IconPicker value={formData.icon} onChange={(value) => onFormChange({ ...formData, icon: value })} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="topic-description">Description</Label>
            <Input
              id="topic-description"
              value={formData.description}
              onChange={(e) => onFormChange({ ...formData, description: e.target.value })}
              placeholder="Brief description shown to visitors"
            />
          </div>

          <div className="space-y-2">
            <Label>Route to Inbox *</Label>
            <Select value={formData.inbox_id} onValueChange={(value) => onFormChange({ ...formData, inbox_id: value })}>
              <SelectTrigger className="cursor-pointer">
                <SelectValue placeholder="Select an inbox" />
              </SelectTrigger>
              <SelectContent>
                {inboxes.map((inbox) => (
                  <SelectItem key={inbox.id} value={inbox.id} className="cursor-pointer">
                    {inbox.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center justify-between pt-2">
            <Label htmlFor="topic-active">Active</Label>
            <Switch
              id="topic-active"
              checked={formData.active}
              onCheckedChange={(checked) => onFormChange({ ...formData, active: checked })}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="cursor-pointer">
            Cancel
          </Button>
          <Button onClick={onSubmit} className="cursor-pointer">
            {isEditing ? 'Save Changes' : 'Create Topic'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
